import { CheckUnexpectedOutput, neverSymbol } from './types';

export abstract class AbstractHandler<I, O> {
  abstract execute(input: I): CheckUnexpectedOutput<O, typeof neverSymbol, O>;
}
